/* eslint-disable */
/**
 * @template D
 * @param {(opts: { readonly method: string, readonly metaData: D, args: any[] }, next: () => Promise<any>) => void} callback
 * @returns {(metaData?: D) => any}
 */
export function genProcess (callback) {
  return function (metaData) {
    return ({ method, args, url }, next) => {
      return callback({ method, metaData, args, url }, next)
    }
  }
}
